module.exports = __webpack_public_path__ + "img/img_hope03.766d644d.webp";